import { useContext } from 'react';
import { AppContext } from './AppContext';

export const useApp = () => {
  const context = useContext(AppContext);
  
  // Check if context has the expected properties (meaning AppProvider is properly wrapping this component)
  if (!context || typeof context.setUser !== 'function') {
    throw new Error('useApp must be used within an AppProvider');
  }
  
  return context;
};